import React from "react";
import CareersContainer from "../../components/Career/Container/CareersContainer";

export default function Careers() {
  return <CareersContainer />;
}
// src/pages/Careers/Careers.jsx